module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0025.jpg?v=0faef1e5";